import React from "react";
import "../../../assets/css/templateBuilder.css";
import "../../../assets/css/addunit.css";
import "../../../assets/css/mainMenu.css";
import ArrowLineRight from "../../../assets/icons/ArrowLineRight.svg";

const Sidebar = ({ master, usedTemplateTypeIds }) => {
  const onDragStart = (event, masterId) => {
    event.dataTransfer.setData("application/reactflow", masterId);
    event.dataTransfer.effectAllowed = "move";
  };

  const getGroupedItems = (items) => {
    const groupedItems = [];
    for (let i = 0; i < items.length; i += 2) {
      groupedItems.push(items.slice(i, i + 2));
    }
    return groupedItems;
  };

  return (
    <div className="row" style={{ marginRight: 0, marginLeft: 0 }}>
      <div className="col-md-3 p-0 left" style={{ width: "300px" }}>
        <div className="accordion" id="accordionExample">
          {master && master.length > 0 ? (
            master.map((item, index) => {
              const isDisabled = usedTemplateTypeIds.includes(
                item.templateType._id
              );
              return (
                <div key={index} className="accordion-item tb-accordion-item">
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button
                      className="accordion-button d-flex align-content-center justify-content-between"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded="true"
                      aria-controls={`collapse${index}`}
                      disabled={isDisabled}
                    >
                      <div className="d-flex gap-3">
                        <p className="m-0 medium-body">
                          {item.templateType.template_type_name}
                        </p>
                      </div>
                      <img className="icon-rotate" src={ArrowLineRight} alt="" />
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body tb-accordion-body">
                      {getGroupedItems(item.templates).map(
                        (group, groupIndex) => (
                          <div
                            key={groupIndex}
                            className="d-flex justify-content-between gap-2 tb-accordion-body align-content-center mb-2"
                          >
                            {group.map((template) => (
                              <span
                                key={template._id}
                                className={`align-content-center text-truncate text-center dndnode ${isDisabled ? "disabled" : ""
                                  }`}
                                onDragStart={(event) =>
                                  !isDisabled &&
                                  onDragStart(event, template._id)
                                }
                                draggable={!isDisabled}
                              >
                                {template.template_name}
                              </span>
                            ))}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
